export enum FORM_SALESFORCE_IDENTIFIERS {
    TIMELINE = 'Project_Timeline',
    INDUSTRY = 'industry',
    APPLICATION = 'Applications_Group',
    COMMENTS = 'comments'
}

export interface PardotFormRequest {
    comments: string;
    company: string;
    consent_on_processing_data: string;
    country: string;
    email: string;
    first_name: string;
    form_submission_url: string;
    iswebform: string;
    job_title: string;
    last_name: string;
    phone: string;
    state_region_us?: string;
    state_region_ca?: string;
    user_role: string;
    user_role_subcategory_end_user: string;
}
